// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1JobSchema } from './v1/jobSchema';

export const listImportJobsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
});

export const listImportJobsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of import jobs
 */
export const listImportJobs200Schema = z.array(z.lazy(() => v1JobSchema));

export const listImportJobsQueryResponseSchema = z.lazy(() => listImportJobs200Schema);
